import React, { useState, useEffect } from 'react';
import { Container, Navbar, Button, NavDropdown, Nav } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Route, Routes, Link, useNavigate } from 'react-router-dom';
import Home from './pages/Home/Home';
import './App.css';
import Profils from './pages/Profile';
import Info from './pages/Info';
import Contacts from './pages/Contacts/Contacts';
import { FaHome, FaSearch, FaUser, FaSignOutAlt, FaSignInAlt, FaUserPlus, FaEdit, FaEnvelope, FaBars, FaQuestionCircle } from 'react-icons/fa';
import { NetworkProvider } from './NetworkProvider';
import { useTranslation } from 'react-i18next';
import { ClipLoader } from 'react-spinners';
import ActivateAccount from './pages/ActivateAccount/ActivateAccount';
import AuthForm from './pages/AuthForm/AuthForm';
import AuthBackground from './pages/AuthForm/AuthBackground';
import SuggestionPage from './pages/Suggestion/Suggestion';
import 'flag-icons/css/flag-icons.min.css';

import HeaderImage from './Assets/TRNS_WHITE.png'

import { useUser } from './UserContext';
import FutureReading from './pages/About/FutureReading';
import FAQ from './pages/FAQ';

function App() {
  const [registrationToggle, setRegistrationToggle] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const navigate = useNavigate();
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const { t, i18n } = useTranslation();
  const [showLoder, setShowLoader] = useState(false);

  const { user, setUser, loadUser, wipeUser } = useUser();

  const homeLink = user ? "home" : "/"

  useEffect(() => {
    loadUserData()
  }, []);

  const loadUserData = async () => {
    setShowLoader(true)
    const newUser = await loadUser()
    if (newUser) {
      navigate('/home');
    } else {
      navigate('/');
    }
    setShowLoader(false)
  }

  function update_form_btn() {
    setRegistrationToggle(!registrationToggle);
    if (window.location.pathname !== '/') {
      navigate('/');
    }
  }

  function validateFields() {
    if (!email || !password || (registrationToggle && (!firstName || !lastName))) {
      setErrorMessage(t('Visi lauki ir jāaizpilda'));
      return false;
    }
    setErrorMessage('');
    return true;
  }

  async function submitLogin(e) {
    e.preventDefault();
    if (!validateFields()) return;

    try {
      setShowLoader(true);
      const user = await NetworkProvider.loginUser({ email, password });
      localStorage.setItem('hasUser', 'true');
      setUser(user)
      await loadUserData()
    } catch (error) {
      console.error('Login error:', error);
      setErrorMessage(t('Pietikšanās neizdevās. Pārbaudiet e-pastu un paroli'));
    } finally {
      setShowLoader(false);
    }
  }

  async function submitRegistration(e) {
    e.preventDefault();
    if (!validateFields()) return;

    try {
      setShowLoader(true);
      await NetworkProvider.registerUser({
        email,
        password,
        confirm_password: confirmPassword,
        first_name: firstName,
        last_name: lastName,
      });

      setSuccessMessage("Reģistrācija veiksmīga, nospiediet uz reģistrācijas linka epastā")
      setEmail('')
      setPassword('')
      setFirstName('')
      setLastName('')
      setConfirmPassword('')
    } catch (error) {
      if (error.response && error.response.data) {
        const errorData = error.response.data;

        if (errorData.email) {
          console.error('Email Error:', errorData.email);
          setErrorMessage(errorData.email);
        } else if (errorData.password) {
          console.error('Password Error:', errorData.password);
          setErrorMessage(errorData.password);
        } else {
          const generalError = errorData.detail || t('Reģistrācija neizdevās. Mēģiniet vēlreiz');
          console.error('General Error:', generalError);
          setErrorMessage(generalError);
        }
      } else {
        console.error(error);
        setErrorMessage(t('Reģistrācija neizdevās. Mēģiniet vēlreiz'));
      }
    } finally {
      setShowLoader(false)
    }
  }



  async function submitLogout(e) {
    e.preventDefault();
    setShowLoader(true)

    try {
      const logoutResult = await NetworkProvider.logoutUser();
      const logoutUrl = logoutResult.logout_url;

      wipeUser()
      setEmail('');
      setPassword('');
      setFirstName('');
      setLastName('');
      setConfirmPassword('');
      if (logoutUrl) {
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = logoutUrl;
        document.body.appendChild(iframe);

        // Remove iframe after a few seconds
        setTimeout(() => {
          document.body.removeChild(iframe);
          setShowLoader(false)
          navigate('/');
        }, 3000);;
      } else {
        navigate('/');
        setShowLoader(false)
      }
    } catch (error) {
      console.error('Logout error:', error);
      setShowLoader(false)
    }
  }

  const [confirmPassword, setConfirmPassword] = useState('');

  function validateFields() {
    if (!email || !password || (registrationToggle && (!firstName || !lastName || !confirmPassword))) {
      setErrorMessage(t('Visi lauki ir jāaizpilda')); // "All fields are required!"
      return false;
    }
    if (registrationToggle && password !== confirmPassword) {
      setErrorMessage(t('Paroles nesakrīt')); // "Passwords do not match!"
      return false;
    }
    setErrorMessage('');
    return true;
  }


  const [error, setError] = useState("");
  const validateEmail = () => {
    if (!email.includes("@")) {
      setError(t('Lūdzu, iekļaujiet „@” e-pasta adresē') + " " + email + " " + t("nav derīga e-pasta adrese"));
    } else {
      setError(""); // Clear the error if email is valid
    }
  };


  return (
    <div className="bg-light min-vh-100 d-flex flex-column">
      <Navbar bg="dark" variant="dark" className="sticky-top">
        <Container fluid>
          <Navbar.Brand className="d-flex align-items-center gap-2">
            <Link to={homeLink} style={{ display: 'inline-block', cursor: 'pointer' }}>
              <img
                src={HeaderImage}
                alt="Logo"
                height="60"
                className="me-2"
              />
            </Link>
          </Navbar.Brand>
          <Navbar.Collapse className="justify-content-end">
            <Nav className="align-items-center">
              <span
                role="button"
                onClick={() => i18n.changeLanguage('lv')}
                className="me-2"
                style={{ cursor: 'pointer' }}
                title="Latviešu"
              >
                <span className="fi fi-lv" style={{ fontSize: '1rem' }}></span>
              </span>
              <div style={{ width: 10 }}></div>
              <span
                role="button"
                onClick={() => i18n.changeLanguage('en')}
                style={{ cursor: 'pointer' }}
                title="English"
              >
                <span className="fi fi-gb" style={{ fontSize: '1rem' }}></span>
              </span>
              <div style={{ width: 10 }}></div>
              {!user ? (
                <>
                  <NavDropdown
                    title={<FaBars className="me-2" />}
                    id="nav-guest-dropdown"
                    align="end"
                    className="dark me-2"
                    menuVariant="dark"
                  >
                    <NavDropdown.Item as={Link} to="/info">
                      <FaHome className="me-2" /> {t("Par Datubāzi")}
                    </NavDropdown.Item>
                    <NavDropdown.Item as={Link} to="/faq">
                      <FaQuestionCircle className="me-2" /> {t("BUJ")}
                    </NavDropdown.Item>
                    <NavDropdown.Item as={Link} to="/kontakti">
                      <FaEnvelope className="me-2" /> {t("Kontakti")}
                    </NavDropdown.Item>
                  </NavDropdown>
                </>
              ) : (
                <>
                  <NavDropdown
                    title={<FaUser className="me-2" />}
                    id="nav-user-dropdown"
                    align="end"
                    className="dark"
                    menuVariant="dark"
                  >
                    <NavDropdown.Item as={Link} to="/home">
                      <FaSearch className="me-2" /> {t("Meklēšana")}
                    </NavDropdown.Item>
                    <NavDropdown.Item as={Link} to="/suggestion">
                      <FaEdit className="me-2" /> {t("Ieteikt labojumu")}
                    </NavDropdown.Item>
                    <NavDropdown.Item as={Link} to="/profils">
                      <FaUser className="me-2" /> {t("Profils")}
                    </NavDropdown.Item>
                    <NavDropdown.Divider />
                    <NavDropdown.Item as={Link} to="/info">
                      <FaHome className="me-2" /> {t("Par Datubāzi")}
                    </NavDropdown.Item>
                    <NavDropdown.Item as={Link} to="/faq">
                      <FaQuestionCircle className="me-2" /> {t("BUJ")}
                    </NavDropdown.Item>
                    <NavDropdown.Item as={Link} to="/kontakti">
                      <FaEnvelope className="me-2" /> {t("Kontakti")}
                    </NavDropdown.Item>
                    <NavDropdown.Divider />
                    <NavDropdown.Item as="button" onClick={submitLogout} className="text-danger">
                      <FaSignOutAlt className="me-2" /> {t("Atteikties")}
                    </NavDropdown.Item>
                  </NavDropdown>
                </>
              )}
            </Nav>
          </Navbar.Collapse>

        </Container>
      </Navbar>
      <Container className="flex-grow-1 d-flex justify-content-center align-items-center py-1">
        <Routes>
          <Route path="/" element={
            <>
              <AuthBackground />
              <AuthForm
                registrationToggle={registrationToggle}
                submitRegistration={submitRegistration}
                submitLogin={submitLogin}
                successMessage={successMessage}
                errorMessage={errorMessage}
                email={email}
                setEmail={setEmail}
                validateEmail={validateEmail}
                error={error}
                firstName={firstName}
                setFirstName={setFirstName}
                lastName={lastName}
                setLastName={setLastName}
                password={password}
                setPassword={setPassword}
                confirmPassword={confirmPassword}
                setConfirmPassword={setConfirmPassword}
                update_form_btn={update_form_btn}
              />
            </>
          } />
          <Route path="/home" element={<Home />} />
          <Route path="/meklesana" element={<Home />} />
          <Route path="/profils" element={<Profils />} />
          <Route path="/suggestion" element={<SuggestionPage />} />
          <Route path="/info" element={<Info />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/kontakti" element={<Contacts />} />
          <Route path="/future-reading" element={<FutureReading />} />
          <Route path="/activate/:uid/:token" element={<ActivateAccount />} />
        </Routes>
      </Container>
      <footer className="footer">
        <p>&copy; 2025 Latvijas Kara muzejs.</p>
      </footer>
      {showLoder && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          backgroundColor: 'rgba(255, 255, 255, 0.8)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999
        }}>
          <ClipLoader color="#000" loading={true} size={40} />
        </div>
      )}
    </div>
  );
}

export default App;
